import AirwallexLogo from '~/assets/svgs/airwallex.svg';
import PaypalLogo from '~/assets/svgs/paypal.svg';
import MastercardLogo from '~/assets/svgs/mastercard.svg';
import VisaLogo from '~/assets/svgs/visa.svg';
import AmexLogo from '~/assets/svgs/amex.svg';
import DinersClubLogo from '~/assets/svgs/diners_club.svg';
import AmericanExpress from '~/assets/svgs/american-express.svg';
import UnionPayLogo from '~/assets/svgs/unionpay.svg';
import Discover from '~/assets/svgs/discover.svg';
import JCB from '~/assets/svgs/jcb.svg';
import CardLogos from '~/components/CardLogos';

export const renderLogoPayment = (medthod: { code: string; title: string }, props?: any) => {
    switch (medthod.code) {
        case 'airwallex_payments_card':
            return {
                title: medthod.title,
                logo: <AirwallexLogo {...props} />
            };
        case 'paypal_express':
            return {
                title: medthod.title,
                logo: <PaypalLogo {...props} />
            };
        case 'stripe_payments':
            return {
                title: 'Credit card',
                logo: <CardLogos />
            };
        default:
            return {
                title: medthod.title,
                logo: <></>
            };
    }
};
